import { SIZE } from 'baseui/button'
import { Modal, ROLE } from 'baseui/modal'
import { useTranslation } from 'react-i18next'
import useComments from './useComments'
import CommentsModalContent from '@/shared/components/contracts/CommentsModalContent'
import ActionTile from '@/containers/SubscriptionFormPageNew/Components/shared/ActionTile/ActionTile'
import IconCarbonCloudLogging from '@/shared/icons/IconCarbonCloudLogging'

const Comments = () => {
  const { t } = useTranslation()
  const { isOpen, openModal, closeModal, comments, handleSubmit, handleUpdate, handleDelete, canMutate } = useComments()

  return (
    <>
      <ActionTile
        label={t('subscriptionTable:view_add_comments')}
        icon={<IconCarbonCloudLogging size={18} />}
        onClick={openModal}
      />
      <Modal onClose={closeModal} isOpen={isOpen} animate autoFocus size={SIZE.full} role={ROLE.dialog}>
        <CommentsModalContent
          comments={comments}
          onSubmit={handleSubmit}
          onUpdate={handleUpdate}
          onDelete={handleDelete}
          canMutate={canMutate}
        />
      </Modal>
    </>
  )
}

export default Comments
